import React from 'react';
import ReactDOM from 'react-dom';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab, faReact, faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import App from './App';

library.add(fab, faReact, faGithub, faLinkedin);

ReactDOM.render(<App />, document.getElementById('root'));
